import React from 'react';
import styled from 'styled-components';

interface LoadMoreButtonProps {
	onClick: () => void;
	loading?: boolean;
	disabled?: boolean;
}

const Button = styled.button`
	height: 32px;
	border-radius: 4px;
	border: 1px solid #cbd5e1;
	background: #ffffff;
	padding: 0 12px;
	${p => p.theme.sys.font?.subheading?.['2']}
	color: #334155;
	cursor: pointer;
	&:hover {
		background: #f8fafc;
	}
	&:disabled {
		cursor: not-allowed;
		opacity: 0.5;
	}
`;

export function LoadMoreButton({onClick, loading = false, disabled = false}: LoadMoreButtonProps) {
	return (
		<Button type="button" onClick={onClick} disabled={disabled || loading}>
			{loading ? 'Loading…' : 'Load more'}
		</Button>
	);
}
